/**
 * External dependencies
 */
import React from 'react';
import BaseModal from 'react-modal';
import { noop } from 'lodash';
import classNames from 'classnames';
import Button from 'components/button';
import Icon from 'components/icon';

/**
 * Style dependencies
 */
import './styles.scss';

const Modal = ({
	children,
	title,
	description,
	headerActions,
	baseClassName,
	className,
	isVisible,
	close,
	onClosed,
	header = true,
	...props
}) => {
	const renderButton = (button, index) => {
		return (
			<Button key={button.action} {...button}>
				<span className={`${baseClassName}__button-label`}>{button.label}</span>
			</Button>
		);
	};

	const renderButtonsBar = () => {
		if (!props.buttons) {
			return null;
		}
		return <div className={`${baseClassName}__action-buttons`}>{props.buttons.map(renderButton, this)}</div>;
	};

	return (
		<BaseModal
			className={classNames(baseClassName, className)}
			isOpen={isVisible}
			onRequestClose={close}
			overlayClassName='modal__overlay'
			ariaHideApp={false}
            onAfterClose={onClosed}
		>
			{header && (
				<div className='modal__header'>
					<div>
						{title && (
							<div className='modal__header-title'>
								<h1>{title}</h1>
							</div>
						)}
						{description && <div className='modal__header-description'>{description}</div>}
					</div>
					{(headerActions && <div className='modal__header-actions'>{headerActions}</div>) || (
						<button className='modal__header-close-btn' onClick={() => close()}>
							<Icon size={25} name='RiCloseLine' />
						</button>
					)}
				</div>
			)}
			<div className={classNames('modal__content')}>{children}</div>
			{renderButtonsBar()}
		</BaseModal>
	);
};

Modal.defaultProps = {
	close: noop,
	onClose: noop,
	shouldCloseOnEsc: true,
	shouldCloseOnOverlayClick: true,
	isVisible: false,
	className: '',
	baseClassName: 'modal',
};

export default Modal;
